import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAboutCard, LazyAboutCardText, LazyAboutCards, LazyAboutGaming, LazyAboutHeader, LazyAboutImage, LazyAboutText, LazyAccountRemovalForm, LazyAccountRemovalFormSuccessBlock, LazyAppBreadcrumbs, LazyAppCookies, LazyAppError, LazyAppFooter, LazyAppFooterMenu, LazyAppFooterMenuMobile, LazyAppHeader, LazyAppHeaderMenu, LazyAppHeaderMenuItem, LazyAppHeaderMobile, LazyAppHeaderMobileMenu, LazyAppHeaderMobileSearch, LazyAppLogo, LazyAppMap, LazyAppPromotions, LazyAppSearch, LazyCategoryBannerLarge, LazyCategoryBannerSmall, LazyCategoryBannerSmallGroup, LazyCategoryCard, LazyCategoryCards, LazyCategoryCardsSection, LazyCategoryHeader, LazyChatbot, LazyContactForm, LazyDriverCardSkeleton, LazyDriversCard, LazyDriversList, LazyFaqQuestions, LazyFaqSkeleton, LazyFeatureLabelGroup, LazyFormSection, LazyLanguageSwitcher, LazyLocationSwitcher, LazyMainFromCanionMainBlockLarge, LazyMainFromCanionMainBlockSmall, LazyMainFromCanyon, LazyMainFromCanyonMain, LazyMainSlider, LazyModalShopList, LazyNewsCard, LazyNewsList, LazyNewsSection, LazyNewsSectionSkeleton, LazyPageBlocks, LazyPageHeader, LazyProductCard, LazyProductCardSkeleton, LazyProductCharacteristics, LazyProductFeatureBadge, LazyProductImagesSlider, LazyProductPageSkeleton, LazyProductShops, LazyProductsCatalog, LazyProductsList, LazyProseBlock, LazyRichAdvantages, LazyRichAdvantagesList, LazyRichFooter, LazyRichHeader, LazyRichImagesGrid, LazyRichVideo, LazySearchHeader, LazySearchNotFound, LazySearchTitle, LazySectionHeader, LazySeoText, LazyServiceCenters, LazyServiceForm, LazyServiceFormDpdFields, LazyServiceFormNovaPoshtaFields, LazyServiceFormUpsFields, LazyShopCard, LazyShopCardSkeleton, LazyShopList, LazySubcategoryHeader, LazySupportForm, LazyTipsSection, LazyTipsSectionAccordion, LazyTipsSectionTabs, LazyUserHelpCards, LazyUiAccordion, LazyUiAccordionItem, LazyUiAccordionNew, LazyUiAutocomplete, LazyUiButton, LazyUiButtonInner, LazyUiCheap, LazyUiCheckbox, LazyUiChip, LazyUiColorSelect, LazyUiDrawer, LazyUiIcon, LazyUiImagesGallery, LazyUiInput, LazyUiLink, LazyUiList, LazyUiModal, LazyUiPagination, LazyUiParallelogram, LazyUiRecaptcha, LazyUiSearchForm, LazyUiSelect, LazyUiSkeletonElement, LazyUiSpinner, LazyUiTabs, LazyUiTabsNew, LazyUiTextarea, LazyUiTreeview, LazyUiTreeviewFilter, LazyUiIcon360Model, LazyUiIconChevronUp, LazyUiIconCookie, LazyUiIconMessage, LazyUiIconSearchNotFound, LazyUiIconYouCan } from '#components'
const lazyGlobalComponents = [
  ["AboutCard", LazyAboutCard],
["AboutCardText", LazyAboutCardText],
["AboutCards", LazyAboutCards],
["AboutGaming", LazyAboutGaming],
["AboutHeader", LazyAboutHeader],
["AboutImage", LazyAboutImage],
["AboutText", LazyAboutText],
["AccountRemovalForm", LazyAccountRemovalForm],
["AccountRemovalFormSuccessBlock", LazyAccountRemovalFormSuccessBlock],
["AppBreadcrumbs", LazyAppBreadcrumbs],
["AppCookies", LazyAppCookies],
["AppError", LazyAppError],
["AppFooter", LazyAppFooter],
["AppFooterMenu", LazyAppFooterMenu],
["AppFooterMenuMobile", LazyAppFooterMenuMobile],
["AppHeader", LazyAppHeader],
["AppHeaderMenu", LazyAppHeaderMenu],
["AppHeaderMenuItem", LazyAppHeaderMenuItem],
["AppHeaderMobile", LazyAppHeaderMobile],
["AppHeaderMobileMenu", LazyAppHeaderMobileMenu],
["AppHeaderMobileSearch", LazyAppHeaderMobileSearch],
["AppLogo", LazyAppLogo],
["AppMap", LazyAppMap],
["AppPromotions", LazyAppPromotions],
["AppSearch", LazyAppSearch],
["CategoryBannerLarge", LazyCategoryBannerLarge],
["CategoryBannerSmall", LazyCategoryBannerSmall],
["CategoryBannerSmallGroup", LazyCategoryBannerSmallGroup],
["CategoryCard", LazyCategoryCard],
["CategoryCards", LazyCategoryCards],
["CategoryCardsSection", LazyCategoryCardsSection],
["CategoryHeader", LazyCategoryHeader],
["Chatbot", LazyChatbot],
["ContactForm", LazyContactForm],
["DriverCardSkeleton", LazyDriverCardSkeleton],
["DriversCard", LazyDriversCard],
["DriversList", LazyDriversList],
["FaqQuestions", LazyFaqQuestions],
["FaqSkeleton", LazyFaqSkeleton],
["FeatureLabelGroup", LazyFeatureLabelGroup],
["FormSection", LazyFormSection],
["LanguageSwitcher", LazyLanguageSwitcher],
["LocationSwitcher", LazyLocationSwitcher],
["MainFromCanionMainBlockLarge", LazyMainFromCanionMainBlockLarge],
["MainFromCanionMainBlockSmall", LazyMainFromCanionMainBlockSmall],
["MainFromCanyon", LazyMainFromCanyon],
["MainFromCanyonMain", LazyMainFromCanyonMain],
["MainSlider", LazyMainSlider],
["ModalShopList", LazyModalShopList],
["NewsCard", LazyNewsCard],
["NewsList", LazyNewsList],
["NewsSection", LazyNewsSection],
["NewsSectionSkeleton", LazyNewsSectionSkeleton],
["PageBlocks", LazyPageBlocks],
["PageHeader", LazyPageHeader],
["ProductCard", LazyProductCard],
["ProductCardSkeleton", LazyProductCardSkeleton],
["ProductCharacteristics", LazyProductCharacteristics],
["ProductFeatureBadge", LazyProductFeatureBadge],
["ProductImagesSlider", LazyProductImagesSlider],
["ProductPageSkeleton", LazyProductPageSkeleton],
["ProductShops", LazyProductShops],
["ProductsCatalog", LazyProductsCatalog],
["ProductsList", LazyProductsList],
["ProseBlock", LazyProseBlock],
["RichAdvantages", LazyRichAdvantages],
["RichAdvantagesList", LazyRichAdvantagesList],
["RichFooter", LazyRichFooter],
["RichHeader", LazyRichHeader],
["RichImagesGrid", LazyRichImagesGrid],
["RichVideo", LazyRichVideo],
["SearchHeader", LazySearchHeader],
["SearchNotFound", LazySearchNotFound],
["SearchTitle", LazySearchTitle],
["SectionHeader", LazySectionHeader],
["SeoText", LazySeoText],
["ServiceCenters", LazyServiceCenters],
["ServiceForm", LazyServiceForm],
["ServiceFormDpdFields", LazyServiceFormDpdFields],
["ServiceFormNovaPoshtaFields", LazyServiceFormNovaPoshtaFields],
["ServiceFormUpsFields", LazyServiceFormUpsFields],
["ShopCard", LazyShopCard],
["ShopCardSkeleton", LazyShopCardSkeleton],
["ShopList", LazyShopList],
["SubcategoryHeader", LazySubcategoryHeader],
["SupportForm", LazySupportForm],
["TipsSection", LazyTipsSection],
["TipsSectionAccordion", LazyTipsSectionAccordion],
["TipsSectionTabs", LazyTipsSectionTabs],
["UserHelpCards", LazyUserHelpCards],
["UiAccordion", LazyUiAccordion],
["UiAccordionItem", LazyUiAccordionItem],
["UiAccordionNew", LazyUiAccordionNew],
["UiAutocomplete", LazyUiAutocomplete],
["UiButton", LazyUiButton],
["UiButtonInner", LazyUiButtonInner],
["UiCheap", LazyUiCheap],
["UiCheckbox", LazyUiCheckbox],
["UiChip", LazyUiChip],
["UiColorSelect", LazyUiColorSelect],
["UiDrawer", LazyUiDrawer],
["UiIcon", LazyUiIcon],
["UiImagesGallery", LazyUiImagesGallery],
["UiInput", LazyUiInput],
["UiLink", LazyUiLink],
["UiList", LazyUiList],
["UiModal", LazyUiModal],
["UiPagination", LazyUiPagination],
["UiParallelogram", LazyUiParallelogram],
["UiRecaptcha", LazyUiRecaptcha],
["UiSearchForm", LazyUiSearchForm],
["UiSelect", LazyUiSelect],
["UiSkeletonElement", LazyUiSkeletonElement],
["UiSpinner", LazyUiSpinner],
["UiTabs", LazyUiTabs],
["UiTabsNew", LazyUiTabsNew],
["UiTextarea", LazyUiTextarea],
["UiTreeview", LazyUiTreeview],
["UiTreeviewFilter", LazyUiTreeviewFilter],
["UiIcon360Model", LazyUiIcon360Model],
["UiIconChevronUp", LazyUiIconChevronUp],
["UiIconCookie", LazyUiIconCookie],
["UiIconMessage", LazyUiIconMessage],
["UiIconSearchNotFound", LazyUiIconSearchNotFound],
["UiIconYouCan", LazyUiIconYouCan],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
